import { render, staticRenderFns } from "./otherPropertyDetail.vue?vue&type=template&id=5f7cac96&"
import script from "./otherPropertyDetail.vue?vue&type=script&lang=js&"
export * from "./otherPropertyDetail.vue?vue&type=script&lang=js&"
import style0 from "./otherPropertyDetail.vue?vue&type=style&index=0&id=5f7cac96&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports